var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-toolbar',{attrs:{"color":_vm.options.color,"flat":""}},[(_vm.options.allowBack)?_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){return _vm.routerGoBack()}}},[_c('v-icon',[_vm._v("mdi-arrow-left")])],1):_vm._e(),_c('v-toolbar-title',[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }